export default __webpack_public_path__ + "static/media/honey-bee.c4bda16f.png";